import { useNavigate } from "react-router-dom";

// First-visit entry splash. Uses the attached artwork exactly (served from /public).
// The artwork already contains the "COME IN" button visually, so the whole image is
// made clickable rather than duplicating a button.
export default function Welcome() {
  const navigate = useNavigate();
  const enter = () => navigate("/story");

  return (
    <div
      data-testid="welcome-page"
      className="flex items-center justify-center p-3"
      style={{
        minHeight: "100svh",
        background: "radial-gradient(circle at 50% 28%, #1a0a2e 0%, #0c0613 100%)",
      }}
    >
      <button
        type="button"
        onClick={enter}
        aria-label="Come in — enter the tavern"
        data-testid="welcome-enter"
        className="group block focus:outline-none focus-visible:ring-2"
        style={{ cursor: "pointer", border: "none", background: "transparent", padding: 0, lineHeight: 0 }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/welcome-entry.png`}
          alt="The Lanterns Are Lit — a moonlit tavern beside a still lake. Welcome, traveler. The fire is warm, the kettle is on, and the lanterns are lit. Come in."
          draggable="false"
          className="rounded-md transition-transform duration-500 group-hover:scale-[1.01]"
          style={{
            maxWidth: "100%",
            maxHeight: "100svh",
            width: "auto",
            height: "auto",
            display: "block",
            boxShadow: "0 20px 80px rgba(0,0,0,0.7)",
          }}
        />
      </button>
    </div>
  );
}
